import {Component, OnInit} from '@angular/core';
import {FooterDataService} from '../../components/footer/footer-data.service';
import {Router} from '@angular/router';
import {BusyService} from '../../services/busy.service';
import {ToastrService} from 'ngx-toastr';
import {AuthService} from '../../../../../firebase/src/lib/services/auth.service';

@Component({
    selector: 'app-unsubscribe',
    templateUrl: './unsubscribe.component.html',
    styleUrls: ['./unsubscribe.component.scss']
})
export class UnsubscribeComponent implements OnInit {
    error = null;

    unsubscribed = false;

    constructor(
        private service: FooterDataService,
        private router: Router,
        private busy: BusyService,
        private toaster: ToastrService,
        public auth: AuthService,
    ) {
    }

    ngOnInit(): void {
    }

    onSubmit() {
        this.error = null;
        this.busy.setState(true);
        this.service.cancelSubscription()
            .subscribe((res) => {
                this.unsubscribed = true;
                this.busy.setState(false);
                return this.router.navigate([]);
            }, (err) => {
                this.error = 'Something goes wrong. Please try later';
                this.toaster.warning(this.translateMessage(err?.error?.detail) || this.error);
                this.busy.setState(false);
            });
    }


    translateMessage(text: string) {
        switch (text) {
            case 'already-cancelled':
                return 'Ви не підписані на жоден пакет';
            case 'already-unsubscribed':
                return 'Ви не підписані на жоден пакет';
            default:
                return text;
        }
    }
}
